import { Component, ViewChild, Input, EventEmitter, Output, OnInit, OnChanges } from '@angular/core';
import { ToasterService } from 'angular5-toaster';
import { ModalComponent } from '../modal.component';
import * as moment from 'moment';
import { User } from '../../core/user';
import { ReviewService } from '../../providers/review.service';
import { AbstractEnhancedReview, UserComment } from '../../core/review';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { StorageService } from '../../storage.service';
import { TramApiService } from '../../tram-api.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'review-form',
    templateUrl: './review-form.component.html',
    styleUrls: ['./review-form.component.scss']
})
export class ReviewFormComponent implements OnInit {
    private rate = 0;
    private review: AbstractEnhancedReview;

    @Input() user: User;
    @Input() isEditMode = false;
    @Input() comment: UserComment;
    @ViewChild('modal') modal: ModalComponent;
    @Output() closed = new EventEmitter();

    reviewForm: FormGroup;

    isEnabled: boolean;
    isLoading: boolean;

    userName: string;

    constructor(private reviewService: ReviewService,
        private api: TramApiService,
        private storage: StorageService,
        private formBuilder: FormBuilder,
        private toaster: ToasterService) {
        storage.isSensitiveDataExist.subscribe(v => {
            if (this.isEnabled === v) {
                return;
            }
            this.isEnabled = v;
        });
    }

    ngOnInit() { }

    open(value: AbstractEnhancedReview | UserComment) {
        this.modal.open();

        if (!value) {
            this.initNewReview();
        } else if (value instanceof AbstractEnhancedReview) {
            this.initReview(value);
        } else {
            this.initComment(value);
        }
    }

    publish() {
        this.isLoading = true;

        const name = this.reviewForm.value.name;
        const message = this.reviewForm.value.message;

        let userPromise: Promise<User>;
        if (this.user && !this.userName) {
            userPromise = this.api.setName(this.user, name);
        }

        if (this.isEditMode) {
            const reviewPromise = this.reviewService.update(this.review, this.comment, message);

            Promise.all([userPromise, reviewPromise])
                .then(data => {
                    const updatedComment = data[1];

                    this.reviewForm.reset();
                    this.isLoading = false;

                    this.toaster.pop('success', null, 'Успешно изменено');
                    this.closed.emit(updatedComment);
                    this.modal.close();
                })
                .catch(error => this.handleError(error));
        } else {
            const reviewPromise = this.reviewService.createReview(this.rate, message);

            Promise.all([userPromise, reviewPromise])
                .then(data => {
                    const review = data[1];

                    this.reviewForm.reset();
                    this.isLoading = false;

                    this.toaster.pop('success', null, 'Отправлено на модерацию');
                    this.closed.emit(review);
                    this.modal.close();
                })
                .catch(error => this.handleError(error));
        }
    }

    cancel() {
        this.modal.close();
    }

    onRateChanged(e: any) {
        this.rate = e;
    }

    private initNewReview() {
        const messageControl = new FormControl('');
        messageControl.setValidators(Validators.required);

        const group = {
            message: messageControl
        };

        if (this.user && this.user.name) {
            this.userName = this.user.name;
        } else {
            const nameControl = new FormControl('');
            nameControl.setValidators(Validators.required);

            group['name'] = nameControl;
        }

        this.reviewForm = this.formBuilder.group(group);
    }
    private initReview(review: AbstractEnhancedReview) {
        const messageControl = new FormControl('');
        messageControl.setValidators(Validators.required);

        const group = {
            message: messageControl
        };

        if (this.user && this.user.name) {
            this.userName = this.user.name;
        } else {
            const nameControl = new FormControl('');
            nameControl.setValidators(Validators.required);

            group['name'] = nameControl;
        }

        this.reviewForm = this.formBuilder.group(group);

        if (review) {
            this.review = review;
            this.comment = this.review.base.comment;
            this.reviewForm.patchValue({
                message: this.review.base.comment.message
            });
        }
    }
    private initComment(comment: UserComment) {
        const messageControl = new FormControl('');
        messageControl.setValidators(Validators.required);

        const group = {
            message: messageControl
        };

        if (this.user && this.user.name) {
            this.userName = this.user.name;
        } else {
            const nameControl = new FormControl('');
            nameControl.setValidators(Validators.required);

            group['name'] = nameControl;
        }

        this.reviewForm = this.formBuilder.group(group);

        if (comment) {
            this.review = comment.parentReview;
            this.comment = comment;
            this.reviewForm.patchValue({
                message: this.comment.message
            });
        }
    }

    private handleError(error: HttpErrorResponse | string) {
        this.isLoading = false;
        if (error instanceof HttpErrorResponse) {
            this.toaster.pop('error', null, error.statusText);
        } else {
            this.toaster.pop('error', null, error);
        }
    }
}



// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/review/review-form.component.ts